



















import Vue from 'vue'
import { Route } from 'vue-router'
import { debounce, pick } from 'lodash'
export default Vue.extend({
  name: 'SearchBar',
  props: {
    value: String
  },
  data () {
    const $self = this
    return {
      origin: null as Route | null,
      buffer: this.value,
      debouncer: debounce(function (value) {
        $self.$emit('input', value)
      }, 500)
    }
  },
  mounted () {
    this.origin = pick(this.$route, ['name', 'query']) as Route
    (this.$refs.searchField as any).focus()
  },
  watch: {
    buffer () {
      this.debouncer(this.buffer)
    }
  }
})
